export default {
    props: {
        draggableContainment: {
            type: String,
            kComposite: 'draggable.containment'
        }, 
        draggableAxis: {
            type: String,
            kComposite: 'draggable.axis'
        }, 
        draggableDragHandle: {
            type: String,
            kComposite: 'draggable.dragHandle'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-window-vue-wrapper/src/KendoWindow/Draggable.js